<div class="card rounded-top-left-0">
  <div class="card-header">
    <h1>Asociar Ubicaciones con Lista de Precios</h1>
  </div>

  <div class="card-body">
    <div class="mb-3 d-flex gap-3 align-items-end flex-wrap">
      <div class="text-muted">
        <i class="fa fa-circle-info"></i>
        Selecciona una <strong>ubicación</strong> a la izquierda y asigna los
        <strong>Destinos</strong> a la derecha.  
        Un destino solo puede pertenecer a una ubicación.
      </div>
    </div>

    <div class="row position-relative">
      <svg id="svg-container" #svgContainer></svg>

      <div class="col">
        <div class="form-group">
          <label class="form-label">Buscar ubicación</label>
          <input
            type="text"
            [(ngModel)]="filterPlaces"
            (input)="debouncedFilterPlaces()"
            class="form-control"
            placeholder="Nombre de la ubicación"
          />
        </div>

        <div class="table-responsive mt-3">
          <table class="table table-bordered" id="table-places">
            <thead>
              <tr class="tr-middle">
                <th></th>
                <th>Nombre</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let p of places"
                [attr.data-id]="p.id"
                (click)="selectPlace(p.id)"
                [class.selected]="p.id === selectedPlaceId"
              >
                <td>
                  <i
                    [ngClass]="
                      p.id === selectedPlaceId
                        ? 'fa-solid fa-circle'
                        : 'fa-regular fa-circle'
                    "
                  ></i>
                </td>
                <td>{{ p.name }}</td>
              </tr>

              <tr *ngIf="places.length === 0">
                <td colspan="3" class="text-muted">
                  <i class="fa fa-circle-info"></i> No se encontraron Ubicaciones.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <app-simple-pagination
          id="places-pag"
          [sizes]="[5,10,20]"
          (changed)="selectedPlaceId = null; refreshPlacesPagination()"
          [elements]="paginationPlaces"
        ></app-simple-pagination>
      </div>

      <div class="col">
        <div class="form-group">
          <label class="form-label">Buscar destino</label>
          <input
            type="text"
            [(ngModel)]="filterPriceLists"
            (input)="debouncedFilterPriceLists()"
            class="form-control"
            placeholder="Nombre del destino"
          />
        </div>

        <div class="table-responsive mt-3">
          <table class="table table-bordered" id="table-priceLists">
            <thead>
              <tr class="tr-middle">
                <th></th>
                <th>Nombre</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let d of priceListLists"
                [attr.data-id]="d.id"
                (click)="togglePriceList(d)"
                [class.selected]="currentRelatedPriceListIds.includes(d.id)"
              >
                <td>
                  <i
                    [ngClass]="
                      currentRelatedPriceListIds.includes(d.id)
                        ? 'fa-solid fa-circle'
                        : 'fa-regular fa-circle'
                    "
                  ></i>
                </td>
                <td>{{ d.name }}</td>
              </tr>

              <tr *ngIf="priceListLists.length === 0">
                <td colspan="3" class="text-muted">
                  <i class="fa fa-circle-info"></i> No se encontraron destinos.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <app-simple-pagination
          id="priceLists-pag"
          [sizes]="[5,10,20]"
          (changed)="refreshPriceListsPagination()"
          [elements]="paginationPriceLists"
        ></app-simple-pagination>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col" *ngIf="selectedPlace">
        <h5>Detalles de la ubicación</h5>
        <ul class="list-group">
          <li class="list-group-item">
            <strong>Nombre:</strong> {{ selectedPlace.name }}
          </li>
        </ul>
      </div>

      <div class="col" *ngIf="currentRelatedPriceLists.length > 0">
        <h5>Destinos Asociados</h5>
        <ul class="list-group">
          <li *ngFor="let d of currentRelatedPriceLists" class="list-group-item">
            {{ d.name }}
          </li>
        </ul>
      </div>

      <div *ngIf="selectedPlaceId" class="d-flex flex-row justify-between mt-3">
        <button
          class="btn btn-success"
          [disabled]="getDisabledSave()"
          (click)="saveAssociation()"
        >
          <ng-container *ngIf="!loading">
            <i class="fa fa-floppy-disk"></i>
          </ng-container>
          <ng-container *ngIf="loading">
            <span class="spinner-border spinner-border-sm"></span>
          </ng-container>
          GUARDAR CAMBIOS
        </button>
      </div>
    </div>
  </div>
</div>
